export const FAQ_FILTER = {
  all: "전체",
  service: "서비스 이용",
  etc: "기타",
};
